import React from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-navy-800 border-t border-navy-700" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-34">
          {/* Info */}
          <div data-id="element-35">
            <h2 className="font-heading font-bold text-4xl text-white mb-8" data-id="element-36">
              Find Us at the <span className="text-ocean-500" data-id="element-37">Harbor</span>
            </h2>

            <div className="space-y-8" data-id="element-38">
              <div className="flex items-start gap-4" data-id="element-39">
                <div className="bg-navy-900 p-3 rounded-full border border-navy-700 text-gold-500" data-id="element-40">
                  <MapPin className="w-6 h-6" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <h3 className="font-heading font-bold text-xl text-white mb-1" data-id="element-43">
                    Location
                  </h3>
                  <p className="text-gray-400" data-id="element-44">
                    12 Maritime Way, Harbor District
                    <br data-id="element-45" />
                    Portland, ME 04101
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-46">
                <div className="bg-navy-900 p-3 rounded-full border border-navy-700 text-gold-500" data-id="element-47">
                  <Clock className="w-6 h-6" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h3 className="font-heading font-bold text-xl text-white mb-1" data-id="element-50">
                    Hours
                  </h3>
                  <p className="text-gray-400" data-id="element-51">Tue - Thu: 5pm - 10pm</p>
                  <p className="text-gray-400" data-id="element-52">Fri - Sat: 5pm - 11pm</p>
                  <p className="text-gray-400" data-id="element-53">Sun: 4pm - 9pm</p>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-54">Closed Mondays</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-55">
                <div className="bg-navy-900 p-3 rounded-full border border-navy-700 text-gold-500" data-id="element-56">
                  <Phone className="w-6 h-6" data-id="element-57" />
                </div>
                <div data-id="element-58">
                  <h3 className="font-heading font-bold text-xl text-white mb-1" data-id="element-59">
                    Contact
                  </h3>
                  <p className="text-gray-400" data-id="element-60">(207) 555-0198</p>
                  <p className="text-gray-400" data-id="element-61">reservations@thedockwall.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="h-full min-h-[400px] w-full bg-navy-900 border-2 border-navy-700 relative group overflow-hidden" data-id="element-62">
            {/* Using an image to simulate a map for this demo */}
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Map location" className="w-full h-full object-cover opacity-50 group-hover:opacity-60 transition-opacity duration-500 grayscale hover:grayscale-0" data-id="element-63" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-64">
              <div className="bg-navy-900/90 p-4 border border-gold-500 backdrop-blur-sm" data-id="element-65">
                <span className="font-heading font-bold text-gold-500" data-id="element-66">
                  THE DOCK WALL
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}